import "./SentMetaData.scss";

import { format, formatDistanceStrict, parseISO } from "date-fns";
import React from "react";

import { DATETIME_FORMAT } from "../utils/constants";

const SentMetaData = ({ datetime, actioned_by }) => {
  const TODAY = Date.now();
  if (!datetime) {
    return null;
  }

  return (
    <p
      className="SentMetaData"
      title={format(parseISO(datetime), DATETIME_FORMAT)}
    >
      Sent {formatDistanceStrict(parseISO(datetime), TODAY)} ago{" "}
      {actioned_by && `by ${actioned_by}`}
    </p>
  );
};
export default SentMetaData;
